<template>
  <div class="ima-user-info">
    <b-icon class="ima-user-info__icon" icon="account_circle" size="is-medium"></b-icon>
    <div class="ima-user-info__text-container">
      <span class="ima-user-info__name">{{user.firstName}} {{user.lastName}}</span>
      <span class="ima-user-info__email">{{user.email}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ima-user-info',
  props: ['user'],
  data () {
    return {}
  }
}
</script>

<style lang="scss">
.ima-user-info {
  align-items: center;
  display: flex;

  &__icon {
    margin-right: 0.5rem;
  }

  &__text-container {
    font-size: 0.9rem;
    line-height: 1.2;
  }

  &__name {
    display: block;
  }

  &__email {
    display: block;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/UserInfo.vue